/**
 * Multi-tab navigation store — EasyAdmin-style.
 *
 * Each opened sidebar menu item becomes a "tab" with its own mounted
 * component. Tabs are kept-alive via display:none toggling so switching
 * back is instant and state (filters, scroll, form values) is preserved.
 */
import { create } from 'zustand';

export interface UoTab {
  key: string; // menu key, e.g. 'platform.user.list'
  label: string;
  path: string; // route path for this tab
  closable: boolean;
}

interface TabsState {
  tabs: UoTab[];
  activeKey: string | null;
  open: (tab: UoTab) => void;
  close: (key: string) => void;
  activate: (key: string) => void;
  reset: () => void;
}

export const useTabsStore = create<TabsState>((set, get) => ({
  tabs: [],
  activeKey: null,
  open: (tab) => {
    const existing = get().tabs.find((t) => t.key === tab.key);
    if (existing) {
      set({ activeKey: tab.key });
      return;
    }
    set({ tabs: [...get().tabs, tab], activeKey: tab.key });
  },
  close: (key) => {
    const tabs = get().tabs.filter((t) => t.key !== key);
    let activeKey = get().activeKey;
    if (activeKey === key) activeKey = tabs[tabs.length - 1]?.key ?? null;
    set({ tabs, activeKey });
  },
  activate: (key) => set({ activeKey: key }),
  reset: () => set({ tabs: [], activeKey: null }),
}));
